import * as signalR from '@microsoft/signalr';
import * as signalRPack from '@microsoft/signalr-protocol-msgpack';

export class SignalHub {
    protected signalNost: string;
    private _connection: signalR.HubConnection = null;
    protected get connection() { return this._connection; }
    constructor() {

    }

    protected subscribeToHub() { }

    protected stopHub() {
        if (this.connection?.state == signalR.HubConnectionState.Connected)
            this.connection.stop();
    }
    protected get isHubConnected() { return this.connection?.state == signalR.HubConnectionState.Connected; }
    protected initHub = async (url: string) => {
        console.log('initHub: ' + url);
        if (this.connection)
            return;
        this._connection = new signalR.HubConnectionBuilder()
            .withUrl(url)
            .withHubProtocol(new signalRPack.MessagePackHubProtocol())
            .configureLogging(signalR.LogLevel.Information)
            .build();

        this.connection.onclose(async () => {
            await this.start(true);
        });
        this.subscribeToHub();
        this.start(false);
    }
    protected get canStartHub() { return true; }
    protected onBeforeHubStarted() { }
    protected async onEndHubStarted() { }
    private async start(reconnect: boolean) {
        try {
            if (!this.canStartHub)
                return;
            this.onBeforeHubStarted();
            if (this.connection.state == signalR.HubConnectionState.Connected)
                await this.connection.stop();
            await this.connection.start();
            await this.onEndHubStarted();
        } catch (err) {
            console.log(err);
            setTimeout(() => this.start(reconnect), 5000);
        }
    }

}


